<template>
	<div id="statement" v-if="menus[3]" v-html="menus[3].menuText">
		项目介绍
	</div>
	<!-- <div data-v-02a38f74="" data-v-077fa876="" id="statement" class="view">
		<h1
			style="margin-top: 23px;margin-bottom: 22px;break-after: avoid;text-align: center;line-height: 70.4px;font-family: 等线;font-size: 29px;text-wrap: wrap">
			<span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 36px;"><strong>2024“星火计划”
					作品原创及授权声明</strong></span>
		</h1>
		<br>
		<p>为了保护版权人的合法权益，根据《中华人民共和国著作权法》等法律规定，“星火计划”——肿瘤科普作品征集项目（以下简称“星火计划”）活动平台做如下版权声明:</p>
		<br>
		<p>1.应征者自向发起方投稿之日起，即一次性、不可撤销地将其在世界范围内对其投稿作品所拥有的著作权及其对投稿作品一切图像的表现物的全部权利（包括内容原创申请权、商标申请权等），以及与此相关的全部衍生权利，在法律许可的方式和途径下，全部无偿、自动、永久转让给发起方；应征人承诺在法律允许的范围内授权发起方（包括发起方认可的第三方）在全世界范围内永久地行使与该投稿作品相关的著作人身权。发起方亦可将授让的权利再次转让给任何第三人。
		</p> <br>
		<p>2.所有投稿的作品（包括初次提交、后续修改、补充、深化或撤回后再提交等任何情形、任何时段提交的任何方案，包括但不限于应征作品中包括的信息、文本、图像、链接、字幕或组成部分）应具有原创性，应征者保证其投稿作品及发起方使用该作品均不存在任何侵权、违约、以及其他任何违法或不当情形。若存在上述情形，发起方将取消其项目参与资格，如已发放证书，发起方有权全部追回，所有法律责任由应征者本人承担。请注意：若中选的投稿作品无法申请知识产权，同样视为无效作品，发起方有权追回所有证书及荣誉，产生任何不良影响，发起方有权要求该应征人赔偿。
		</p> <br>
		<p>3.所有投稿作品的知识产权归发起方所有(包括初次提交、后续修改、补充、深化或撤回后再提交等任何情形、任何时段提交的任何方案，包括但不限于著作权，对作品的一切平面、立体或电子载体的全部权利)，发起方有权永久使用被采用的作品，并进行任何形式的使用、开发、修改、授权、许可或保护等活动。发起方拥有对其作品不完善之处进行修改的权利，拥有决定设计方案使用场合、使用方式、使用时间的权利。
		</p> <br>
		<p>4.应征者除根据本征集公告获得相应奖励和荣誉外，不再获得其他费用。对本征集公告及其附件产生的任何疑义，发起方保留最终解释权。任何与本次征集有关的未尽事宜，均由发起方进一步制定相应规定并进行解释。</p> <br>
		<p>5.如投稿作品相同或相似，以先应征者优先(以收到应征文件时间为先后次序)。所有应征文件恕不退稿，请应征者自留底稿。</p> <br>
		<p>6.应征者参与本次征集活动所发生的一切费用和支出，除与发起方有另行约定外，均由应征者自行承担。</p> <br>
		<p>7.如应征者提交的作品或发起方对该作品的任何形式的使用导致发起方及由其授权的单位面临或遭受任何第三方的索赔、投诉/诉讼/仲裁等情形，或使发起方及由其授权的单位遭受任何名誉、声誉或经济上的直接或间接损失，无论应征者有无过错，应征者均应当按照发起方要求，采取足够而适当的措施以保证发起方对该设计方案的使用且免受上述任何影响。应征者应当自行承担由此产生的费用，并赔偿由此给发起方造成的全部损失（包括但不限于声誉损失、直接经济损失，发起方应当向第三方承担的损失）。
		</p> <br>
		<p>8.自投稿日起，即视应征者同意以上法律声明，接受本规则的相关规定并同意放弃任何异议的权利。</p>

	</div> -->
</template>

<script>
	import {
		ProjectPage // 优秀稿件
	} from '@/request/api';
	export default {
		name: 'statement',
		data() {
			return {
				menus: ''
			}
		},
		created() {
			this.getProjectPage();
		},
		mounted() {},
		methods: {
			getProjectPage() {
				ProjectPage().then(res => {
					if (res.code == 200) {
						this.menus = res.data.menus
					}
				}).catch(err => {
					console.error('查询项目信息失败:', err)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	#statement {
		* {
			text-align: justify;
		}

		h3 {
			font-weight: bold;
			margin-bottom: 10px;
			font-size: 18px;
		}

		p {
			font-size: 14px;
			margin-bottom: 10px;
			text-align: justify;
		}
	}
</style>